import { articles } from '@/mocks/articles';
import { categories } from '@/mocks/categories';
import type { Article } from '@/types/content';

export function getCategory(slug: string) {
  return categories.find((category) => category.slug === slug);
}

export function getArticlesByCategory(slug: string): Article[] {
  return articles.filter((article) => article.category === slug) as Article[];
}

export function getArticleBySlug(slug: string): Article | undefined {
  return articles.find((article) => article.slug === slug) as Article | undefined;
}

export function getFeaturedArticles(limit = 3): Article[] {
  return (articles.filter((article) => article.featured) as Article[]).slice(0, limit);
}

export function getLatestArticles(limit = 6): Article[] {
  return [...(articles as Article[])]
    .sort((a, b) => (a.date < b.date ? 1 : -1))
    .slice(0, limit);
}

export function getHotArticles(limit = 5): Article[] {
  return [...(articles as Article[])].sort((a, b) => b.heat - a.heat).slice(0, limit);
}

export function getRelatedArticles(article: Article, limit = 3): Article[] {
  const sameCategory = (articles as Article[]).filter(
    (item) => item.category === article.category && item.slug !== article.slug,
  );
  const others = (articles as Article[]).filter(
    (item) => item.category !== article.category && item.slug !== article.slug,
  );
  return [...sameCategory, ...others].slice(0, limit);
}

export function searchArticles(keyword: string): Article[] {
  const q = keyword.trim().toLowerCase();
  if (!q) return [];
  return (articles as Article[]).filter((article) => {
    const categoryName = getCategory(article.category)?.name ?? '';
    const haystack = [article.title, article.excerpt, categoryName, ...article.tags]
      .join(' ')
      .toLowerCase();
    return haystack.includes(q);
  });
}

export function formatDate(date: string): string {
  const parsed = new Date(date);
  if (Number.isNaN(parsed.getTime())) return date;
  return parsed.toLocaleDateString('zh-CN', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  });
}